import { addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Role } from "../types";

type Props = {
  ticketId: string;
  message: string;
  adminEmail: string;
};

export const createSupportMessage = async ({
  ticketId,
  message,
  adminEmail,
}: Props) => {
  const collectionRef = collection(
    db,
    `customerSupportTickets/${ticketId}/messages`,
  );
  await addDoc(collectionRef, {
    message,
    from: Role.Support,
    admin: {
      email: adminEmail,
    },
    timestamp: new Date(),
  });
};
